import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-lease-contract-date.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-lease-contract-date.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SaShortDatePipe } from "../../../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../../shared/models/alert";
import { AppControllerService } from "../../../../../../app-controller.service";
let SearchLeaseContractDateComponent = class SearchLeaseContractDateComponent {
    calendar;
    formatter;
    applicationSearchService;
    aflaModuleStrategyService;
    saShortDatePipe;
    appController;
    noOfMonthsToDisplay;
    leaseContractDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.leaseContractDateFormControl;
    leaseEndDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.leaseEndDateFormControl;
    leaseStartDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.leaseStartDateFormControl;
    endDateLabel = ApplicationSearchConstants.FORM_CONTROLS.endDateLabel;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    datePlaceholder = ApplicationSearchConstants.FORM_CONTROLS.datePlaceholder;
    startDateLabel = ApplicationSearchConstants.FORM_CONTROLS.startDateLabel;
    leaseStartDate;
    leaseEndDate;
    leaseContractDateForm;
    applicationSearchCallback;
    isSelectedToDate = false;
    isDisabledToCreatedDate = true;
    hoveredDate = null;
    constructor(calendar, formatter, applicationSearchService, aflaModuleStrategyService, saShortDatePipe, appController) {
        this.calendar = calendar;
        this.formatter = formatter;
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.saShortDatePipe = saShortDatePipe;
        this.appController = appController;
        // this.leaseStartDate = calendar.getToday();
        // this.leaseEndDate = calendar.getToday();
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const startDate = this.leaseStartDate ? new Date(this.leaseStartDate.year, this.leaseStartDate.month - 1, this.leaseStartDate.day) : null;
        if (startDate)
            startDate.setDate(startDate.getDate() - 2);
        const endDate = this.leaseEndDate ? new Date(this.leaseEndDate.year, this.leaseEndDate.month - 1, this.leaseEndDate.day) : null;
        this.applicationSearchCallback(this.applicationSearchService.searchByLeaseContractDate(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, startDate ? this.saShortDatePipe.transform(startDate) : null, endDate ? this.saShortDatePipe.transform(endDate) : null));
    }
    // to be consistent, user must click 'Search' before we trigger the search for applications
    onDateSelection(date, dateCtrl) {
        if (dateCtrl === "startDate")
            this.leaseStartDate = date;
        else
            this.leaseEndDate = date;
    }
    clearDate(dateCtrl) {
        if (dateCtrl === "startDate")
            this.leaseStartDate = null;
        else
            this.leaseEndDate = null;
    }
    setAutoClose() {
        return "'outside'";
    }
    isHovered(date) {
        return false;
    }
    isInside(date) {
        return false;
    }
    isRange(date) {
        return false;
    }
    validateInput(currentValue, input) {
        const parsed = this.formatter.parse(input);
        if (!parsed && input !== "") {
            this.appController.showMessage(`${SharedConstants.DATE_INPUT_CONTROL_VALIDATION}`, AlertType.Warning);
            return currentValue;
        }
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
    setUpForm() {
        this.leaseContractDateForm = new FormGroup({
            leaseStartDateFormControl: new FormControl(null),
            leaseEndDateFormControl: new FormControl(null)
        });
    }
    static ctorParameters = () => [
        { type: NgbCalendar },
        { type: NgbDateParserFormatter },
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: SaShortDatePipe },
        { type: AppControllerService }
    ];
    static propDecorators = {
        noOfMonthsToDisplay: [{ type: Input }]
    };
};
SearchLeaseContractDateComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-lease-contract-transfer-date",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchLeaseContractDateComponent);
export { SearchLeaseContractDateComponent };
